import type CreativeSDK from '@cesdk/cesdk-js';
import { GQLProductSideFragment } from '@theprintbar/graphql';
import { isExclusionBlock } from '@theprintbar/shared';

export { isExclusionBlock };

export async function addExclusionZonesToPage(editor: CreativeSDK, side: GQLProductSideFragment, page: number) {
	const { block } = editor.engine;

	//Remove any old exclusion blocks
	const existing = block.getChildren(page).filter(child => isExclusionBlock(child, editor));
	existing.forEach(e => block.destroy(e));

	side.exclusions?.forEach(({ width, height, top, left }) => {
		const pageX = block.getGlobalBoundingBoxX(page);
		const pageY = block.getGlobalBoundingBoxY(page);
		const pageHeight = block.getHeight(page);
		const pageWidth = block.getWidth(page);

		//Get real world coordinates using percentage values
		width = pageWidth * (width / 100);
		height = pageHeight * (height / 100);
		left = pageX + pageWidth * (left / 100);
		top = pageY + pageHeight * (top / 100);

		const exclusionBlock = block.create('graphic');
		const rectShape = block.createShape('rect');
		block.setMetadata(exclusionBlock, 'exclusion', 'true');
		block.setWidth(exclusionBlock, width);
		block.setHeight(exclusionBlock, height);
		block.setPositionX(exclusionBlock, left);
		block.setPositionY(exclusionBlock, top);
		block.appendChild(page, exclusionBlock);
		const solidColor = block.createFill('color');
		block.setColor(solidColor, 'fill/color/value', { r: 1, g: 0, b: 0, a: 0.4 });
		block.setFill(exclusionBlock, solidColor);
		block.setOpacity(exclusionBlock, 0.4);
		block.setShape(exclusionBlock, rectShape);
		block.setAlwaysOnTop(exclusionBlock, true);
		block.setVisible(exclusionBlock, true);
		block.setStrokeColor(exclusionBlock, { r: 1, g: 1, b: 1, a: 1 });
		block.setStrokeWidth(exclusionBlock, 2);
		block.setStrokeStyle(exclusionBlock, 'Dashed');
		block.setStrokeEnabled(exclusionBlock, true);
		block.setStrokePosition(exclusionBlock, 'Inner');
		block.setScopeEnabled(exclusionBlock, 'editor/select', false);
	});
}

export default {
	addExclusionZonesToPage,
	isExclusionBlock,
};
